import { render, staticRenderFns } from "./add-random.vue?vue&type=template&id=0c530291&"
import script from "./add-random.vue?vue&type=script&lang=ts&"
export * from "./add-random.vue?vue&type=script&lang=ts&"
import style0 from "./add-random.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports